export default __webpack_public_path__ + "static/media/contact-bg.4b5f6691.jpg";